var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['add-node-btn-box',_vm.isDisabled]},[_c('div',{staticClass:"add-node-btn"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasBtn),expression:"hasBtn"}],staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('onAddNode')}}},[_c('span',{staticClass:"el-icon-plus add-icon"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }